import Vue from "vue"
import utilsApi from "@/api/utils"
import { createFetchPageAction } from "@/store/helpers/createFetchPageAction"

const initialObject = {
  _id: undefined,
  email_template: undefined,
  name: undefined,
  subject: undefined,
  receipts: undefined,
  type: undefined,
  config: undefined,
  body: undefined,
  status: undefined,
  createdAt: undefined,
  updatedAt: undefined
}

const initialState = {
  email_templates: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}
const state = Object.assign({}, initialState)

const getters = {
  email_templates: (state) => state.email_templates,
  email_templatesIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  email_templatesError: (state) => state.error,
  email_templates_Object: (state) => state.object,
  email_templates_selected: (state) => state.selected
}
const actions = {
  async DELETE_email_templates({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("email-templates", object)
    if (apiResponse != null) {
      //commit("EMAILTEMPLATES_SETTING", apiResponse)

      dispatch("FETCH_PAGE_email_templates", state.page)
      return true
    } else {
      commit("EMAILTEMPLATES_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_email_templates({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_email_templates", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_email_templates", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_email_templatesState({ commit }, payload) {
    commit("SET_email_templates", payload)
    return true
  },
  async UPDATE_email_templates({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.updateObject("email-templates", object)
    if (apiResponse != null) {
      commit("EMAILTEMPLATES_SETTING", apiResponse)
      dispatch("FETCH_PAGE_email_templates", state.page)
      return true
    } else {
      commit("EMAILTEMPLATES_ERROR")
      return false
    }
  },
  async CREATE_email_templates({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("email-templates", object)
    if (apiResponse != null) {
      commit("SET_email_templates", {
        param: "object",
        value: apiResponse.email_template
      })
      dispatch("FETCH_PAGE_email_templates", state.page)
      return true
    } else {
      commit("EMAILTEMPLATES_ERROR")
      return false
    }
  },
  async FETCH_email_templates({ commit }) {
    let apiResponse = await utilsApi.getObjects("email-templates")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("EMAILTEMPLATES_SETTING", apiResponse)
      return true
    } else {
      commit("EMAILTEMPLATES_ERROR")
      return false
    }
  },

  FETCH_PAGE_email_templates: createFetchPageAction(
    "email-templates",
    "EMAILTEMPLATES_SETTING",
    "EMAILTEMPLATES_ERROR",
    "email_templates"
  ),

  UPDATE_OBJECT_email_templates({ commit }, payload) {
    commit("SET_OBJECT_EMAILTEMPLATE", payload)
    return true
  },
  CLEAN_OBJECT_email_templates({ commit }) {
    commit("SET_OBJECT_EMAILTEMPLATE_INITIAL")
    return true
  },
  async CLEAN_STORE_email_templates({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_email_templates", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_email_templates({ commit }, payload) {
    commit("SET_SELECTED_EMAILTEMPLATES", payload)
    return true
  }
}
const mutations = {
  EMAILTEMPLATES_SETTING: (
    state,
    { email_templates, count = undefined, page }
  ) => {
    state.count = count ?? state.email_templates.length
    state.page = page ?? state.page
    state.email_templates = email_templates
    state.fetched = true
    state.error = false
  },
  EMAILTEMPLATES_ERROR: (state) => {
    state.email_templates = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_EMAILTEMPLATE: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_EMAILTEMPLATE_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_EMAILTEMPLATES: (state, selectedPages) => {
    state.selected = selectedPages
  },
  SET_email_templates: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
